import styles from './Campaign.module.scss'
import classNames from 'classnames'

import Markdown from '../Markdown/Markdown'
import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import Card from '../ui/Card/Card'
import Image from '../ui/Image/Image'

import { getImageUrl, isArabic } from '../../utils'
import useIsMobile from '../../hooks/useIsMobile'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

const CampaignBenefits = ({
  title,
  description,
  cardHeader,
  cards,
  avoidRtl,
}) => {
  const isMobile = useIsMobile()
  const { language } = useLanguage()
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(isMobile ? 250 : 600, avoidRtl)

  return (
    <div className={styles.benefitsContainer}>
      {(title || description) && (
        <div className={classNames('page-container', styles.benefitsHeader)}>
          {title && <h2>{title}</h2>}
          {description && (
            <Markdown
              content={description}
              className={styles.descriptionRichText}
            />
          )}
        </div>
      )}
      <div className={styles.bottomContainer}>
        <HeaderScrollHandler
          subTitle={cardHeader}
          scrollLeft={scrollLeft}
          scrollRight={scrollRight}
          isAtEnd={isAtEnd}
          isAtStart={isAtStart}
          className={classNames('page-container', styles.benefitsCardHeader)}
          subTitleClass={styles.benefitsSubtitle}
          avoidRtl={avoidRtl}
        />
        <div className={styles.benefitsCardContainer} ref={scrollRef}>
          {cards?.map((item) => (
            <Card
              key={'keyfeatures' + item?.id}
              className={classNames(
                styles.benefitsCard,
                !avoidRtl && isArabic(language?.code)
                  ? styles.arabic_benefitsCard
                  : ''
              )}
            >
              <Image
                src={getImageUrl(item.image)}
                alt={item?.image?.alternativeText}
              />
              <div className={styles.benefitsCardDetails}>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CampaignBenefits
